import { FilterCreationConfig } from "./filterCreationConfig";
import { useFilterDataDependencies } from "./useFilterDataDependencies";

/**
 * Main hook for generating filter options from Algolia data
 * Now uses modular components for better maintainability and testability
 */
export const useFilterOptionsGeneratorFromAlgolia = (
  filterCreationConfig: FilterCreationConfig[],
) => {
  return useFilterDataDependencies(
    filterCreationConfig as FilterCreationConfig[],
  );
};
